import { render } from "./HmdaWithdrawalDashboard.vue?vue&type=template&id=62ba3a4f&scoped=true"
import script from "./HmdaWithdrawalDashboard.vue?vue&type=script&lang=js"
export * from "./HmdaWithdrawalDashboard.vue?vue&type=script&lang=js"

import "./HmdaWithdrawalDashboard.vue?vue&type=style&index=0&id=62ba3a4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ba3a4f"]])

export default __exports__